module.exports = __webpack_public_path__ + "static/media/Autodesk University Global Experience.eb6d333f.png";